<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('ymsQuestionnaire_exportQuantityStatistics')">
      <Dropdown transfer @on-click="changeExportBtn">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        @on-selection-change="tableChange"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {pageJump} from "@/utils/common";

export default {
  name: "questionnaireStatistics",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        ymsQuestionnaireId: null,
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [],
      tableData: [],
      selectTableData: []
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      let v = this;
      if (v.getPermission('ymsQuestionnaire_queryQuantityStatistics')) {
        if (this.$route.query) {
          this.pageParams.ymsQuestionnaireId = this.$route.query.ymsQuestionnaireId;
        }
        v.tableLoading = true;
        v.tableData = [];
        v.total = 0;
        v.axios.post(api.post_ymsQuestionnaire_queryQuantityStatistics, v.pageParams).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              if (v.tableData.length > 0) {
                v.tableData.map((item) => {
                  item.ymsQuestionnaireQuestionList.map((ele, idx) => {
                    item['questionContent_' + ele.ymsQuestionnaireQuestionId] = ele.answerContent;

                  });
                });
              }
              v.total = data.total;
            }
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      data.map((item) => {
        if (item.answerMerchantId) {
          this.selectTableData.push(item.answerMerchantId);
        }
      });
    },
    // 选择导出数据   类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      let v = this;
      v.exportType = value;
      let query = JSON.parse(JSON.stringify(v.pageParams));
      if (value === '1') {
        if (v.selectTableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        } else {
          query.answerMerchantIds = v.selectTableData;
        }
      } else {
        if (v.tableData.length <= 0) {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      v.axios.post(api.post_ymsQuestionnaire_exportQuantityStatistics, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          v.pageParamsStatus = true;
          v.$refs['selection'].selectAll(false);
          v.selectTableData = [];
          let taskNumber = res.data.datas;
          setTimeout(() => {
            pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
          }, 30);
        }
      });
    },
    // 处理列表字段的数据
    handlerColumn(data) {
      let v = this;
      let columnList = [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003079'),
          key: 'answerMerchantId',
          align: 'center',
          minWidth: 130
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003080'),
          key: 'answerStarttime',
          align: 'center',
          minWidth: 180
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003081'),
          key: 'answerEndtime',
          align: 'center',
          minWidth: 180
        }
      ];
      let columns = [];
      if (data && data.length > 0) {
        let titleList = data[0].ymsQuestionnaireQuestionList;
        titleList.map((item) => {
          columns.push({
            title: item.questionTitle,
            align: 'center',
            minWidth: 160,
            ymsQuestionnaireQuestionId: item.ymsQuestionnaireQuestionId
          });
        });
        if (columns.length > 0) {
          columns.map((item) => {
            item.render = (h, params) => {
              let newList = params.row['questionContent_' + params.column.ymsQuestionnaireQuestionId] || [];
              return h('div', newList.join('、'));
            };
          });
        }
      }
      v.tableColumns = [...columnList, ...columns];
      v.$forceUpdate();
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听列表数据变化
    tableData: {
      handler(data) {
        this.handlerColumn(data);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped>

</style>
